import styled from 'styled-components';
import theme, { rtlFlip } from 'src/utils/theme';
import { Button as Btn } from './Button';

export const Button = styled(Btn)`
  button {
    min-width: 75px;
    @media (min-width: ${theme.sz.md}) {
      max-width: 85px;
      min-height: 112px;
    }
  }

  button div {
    flex-grow: 0;
  }
`;

export const ButtonThatFlipsForRTL = styled(Btn)`
  button {
    min-width: 75px;
    @media (min-width: ${theme.sz.md}) {
      max-width: 85px;
      min-height: 112px;
    }
  }

  button div {
    flex-grow: 0;
  }

  transform: scaleX(${rtlFlip(theme)}); // Flip the entire button for RTL (including icon)
`;

export const ButtonText = styled.span`
  display: inline-block;
  transform: scaleX(${rtlFlip(theme)}); // Counter-flip only the text content to display correctly
`;
